import { FeedbackDialogService } from './feedback-dialog.service';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-general-feedback-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, DialogModule, ButtonModule],
  templateUrl: './general-feedback-dialog.component.html',
  styleUrls: ['./general-feedback-dialog.component.scss'],
})
export class GeneralFeedbackDialogComponent implements OnChanges {
  readonly surveyFormUrl = 'https://forms.cloud.microsoft/r/eTzaNYutxd';

  @Input() isFeedbackEnabled = false;
  @Input() userId: string | null = null;

  visible = false;

  private actionHandled = false;

  constructor(private storageService: FeedbackDialogService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['isFeedbackEnabled'] || changes['userId']) && this.isFeedbackEnabled && this.userId) {
      this.visible = this.storageService.shouldShowSurvey(this.userId);
    }
  }

  answerSurvey() {
    window.open(this.surveyFormUrl, '_blank');
  }

  decline(): void {
    if (!this.userId) {
      return;
    }
    this.actionHandled = true;
    this.storageService.setPermanentDismissal(this.userId, 'declined');
    this.visible = false;
  }

  remindLater(): void {
    if (!this.userId) {
      return;
    }
    this.actionHandled = true;
    this.storageService.setRemindLater(this.userId);
    this.visible = false;
  }

  onDialogHide(closebutton?: boolean): void {
    if (closebutton) return;

    if (!this.actionHandled && this.userId) {
      this.storageService.setRemindLater(this.userId);
    }
    this.actionHandled = false;
  }
}
